/**
 * Traducciones del clúster de dashboard que faltaban: ListaVaults, Polvo,
 * PanelComisiones. Claves EXACTAS extraídas del código (no editar las claves).
 */
export const RESTO: Record<string, string> = {
  "Conecta tu wallet para ver lo que tienes suelto.": "Connect your wallet to see what you have lying around.",
  "Convertirlo todo a": "Convert it all to",
  "cargando…": "loading…",
  "sin estables aquí": "no stables here",
  "En la red": "On the network",
  "monedas con saldo": "coins with a balance",
  "mirando las demás redes…": "checking the other networks…",
  "en total": "in total",
  "Ninguna": "None",
  "solo menos de $": "only under $",
  "Releer": "Refresh",
  "no contesta su RPC": "its RPC isn't responding",
  "Sin {sim} para el gas — no puedes mover estos tokens hasta tener un poco.": "No {sim} for gas — you can't move these tokens until you have some.",
  "Traer ~${usd} de gas desde {red}": "Bring ~${usd} of gas from {red}",
  "Sin {sim} para el gas, y no tienes gas en otra red para traer. Manda un poco de {sim} a esta red desde un exchange.": "No {sim} for gas, and you have no gas on another network to bring over. Send some {sim} to this network from an exchange.",
  "Nada suelto aquí por debajo de ese importe.": "Nothing lying around here below that amount.",
  "Nada suelto aquí.": "Nothing lying around here.",
  "No tienes nada suelto en ninguna de las redes. Nada que barrer.": "You have nothing lying around on any network. Nothing to sweep.",
  "Marcadas": "Selected",
  "buscando rutas…": "finding routes…",
  "barriendo…": "sweeping…",
  "Barridas {n} monedas a {token}. ": "Swept {n} coins into {token}. ",
  "No se barrió ninguna. ": "None were swept. ",
  "{n} fallaron, cada una dice por qué. ": "{n} failed, each says why. ",
  "Lo paramos ahí.": "We stopped there.",
  "ver ↗": "view ↗",
  "hecho": "done",
  "Calculando…": "Calculating…",
  "Calcular lo que recibo": "Calculate what I get",
  "Parar al acabar esta": "Stop after this one",
  "Barrer {n} moneda a {token}": "Sweep {n} coin into {token}",
  "Barrer {n} monedas a {token}": "Sweep {n} coins into {token}",
  "Va una por una y cada una pide su firma: puedes parar cuando quieras y lo ya barrido se queda hecho. Keellabs cobra el {pct}% de cada conversión, igual que en el puente.": "It goes one by one and each asks for its signature: you can stop whenever you want and whatever's already swept stays done. Keellabs charges {pct}% on each conversion, same as on the bridge.",
  "Es el gas de esta red: se barre dejando lo justo para pagar el envío": "This is the gas for this network: it sweeps while leaving just enough to pay for the transfer",
  "buscando ruta…": "finding route…",
  "enviando…": "sending…",
  "hecho ✓ ↗": "done ✓ ↗",
  "hecho ✓": "done ✓",
  "Ganancias": "Earnings",
  "La posición todavía no ha generado ninguna comisión.": "The position hasn't generated any fees yet.",
  "Ganancias generadas · total": "Earnings generated · total",
  "{n} ya cobrado": "{n} already collected",
  "aún sin cobrar en la posición": "still uncollected in the position",
  "Día": "Day",
  "Semana": "Week",
  "Mes": "Month",
  "Barras": "Bars",
  "Acumulado": "Cumulative",
  "Comisiones cobradas por período": "Fees collected per period",
  "Apartado para ti": "Set aside for you",
  "retirable ahora mismo": "withdrawable right now",
  "nada apartado (lo reinvertiste o retiraste)": "nothing set aside (you reinvested or withdrew it)",
  "Reinvertido": "Reinvested",
  "volvió a la posición a trabajar": "back in the position working",
  "ya fuera del vault": "already out of the vault",
  "Comisión Keellabs": "Keellabs fee",
  "{pct}% de lo cobrado": "{pct}% of what's collected",
  "Sin cobrar aún": "Not collected yet",
  "acumulado en la posición": "accrued in the position",
  "Total en {u} al precio de ahora, no al del día de cada cobro. «Apartado» es el saldo retirable de ahora mismo; el gráfico cuenta lo cobrado cuando se cobró.": "Total in {u} at today's price, not at the price on each collection day. «Set aside» is the balance withdrawable right now; the chart counts what was collected when it was collected.",
  "{n} cobro(s) antiguos sin fecha quedan fuera del gráfico.": "{n} old collection(s) without a date are left off the chart.",
  "comisiones cobradas acumuladas": "cumulative fees collected",
  "comisiones cobradas por período": "fees collected per period",
  "No pude leer tus vaults de {red}.": "Couldn't read your {red} vaults.",
  "Aún no tienes ninguna piscina en {red}.": "You don't have any pool on {red} yet.",
  "Elige una pool abajo y ábrela: tarda tres firmas.": "Pick a pool below and open it: it takes three signatures.",
  "No tienes ninguna piscina abierta en {red}.": "You don't have any open pool on {red}.",
  "Vacías: sacaste todo. El vault sigue en la cadena con su historial, y": "Empty: you took everything out. The vault stays on-chain with its history, and",
  "volver a abrir en ese par": "reopen on that pair",
  "crea una piscina nueva": "creates a new pool",
  ", con su propio dinero y sus propios ajustes. Ésta se queda aquí como registro.": ", with its own money and its own settings. This one stays here as a record.",
  "se puede volver a abrir": "can be reopened",
  "en su mismo par — elígelo abajo como cualquier otra pool y se reutiliza, con su cuota y sus ajustes ya puestos.": "on the same pair — pick it below like any other pool and it gets reused, with its fee tier and settings already set.",
  "en una piscina": "in one pool",
  "en {n} piscinas": "in {n} pools",
  "de {n}": "of {n}",
  "todas tienen posición abierta": "all have an open position",
  "el resto está sin abrir": "the rest are unopened",
  "Cobrando ahora": "Earning now",
  "ninguna posición abierta todavía": "no open position yet",
  "todas dentro de su rango": "all within their range",
  "las de fuera no cobran hasta que el robot las reajuste": "the ones out of range don't earn until the bot rebalances them",
  "Necesitan algo": "Need something",
  "Nada": "None",
  "ninguna está parada ni a medio abrir": "none are paused or half-opened",
  "{n} piscina": "{n} pool",
  "{n} piscinas": "{n} pools",
  "hay alguna en pausa": "some are paused",
  "hay dinero dentro sin posición abierta": "there's money inside with no open position",
  "Depositado, falta abrir la posición.": "Deposited, position not opened yet.",
  "Tienes": "You have",
  "dentro sin trabajar: la creación se quedó a medias (casi siempre por gas). Tu dinero está seguro — solo falta un paso.": "inside not working: the setup was left halfway (almost always due to gas). Your money is safe — just one step left.",
  "Terminar de abrir →": "Finish opening →",
  "la dirección": "the address",
  "por {activo}": "per {activo}",
  "sin posición abierta": "no open position",
  "depositado, sin abrir": "deposited, not opened",
  "reserva {n}": "reserve {n}",
  "{pct}% sobre tu capital": "{pct}% on your capital",
  "{n} sin barrer": "{n} unswept",
  "esta versión no lo publica": "this version doesn't report it",
  "desde que se abrió": "since it was opened",
  "aún sin abrir": "not opened yet",
  "cerrada": "closed",
  "falta abrir": "needs opening",
  "actualizable": "upgradable",
};
